(function(){
    angular
        .module('appback')
        .directive('ngBiopsia125', biopsia125);

        biopsia125.$inject = ['ResultadosService','$timeout'];
        function biopsia125(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=biopsia125.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  centro: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.loadingFields = false;
		            	//console.log(scope.item.resultado);
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { nodulos : [{ }] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { nodulos : [{ }] }};
				            }
				        }

		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                     }

	                     scope.borrarNodulo = function(index){
	                     	scope.item.resultado.extra.resultado.nodulos.splice(index,1);
	                     }

	                     scope.nuevoNodulo = function(){
	                     	scope.item.resultado.extra.resultado.nodulos.push({});
	                     }

	                     scope.buscarplantillamargen = function(nod){
	                     	scope.loadingFields = true;
	                     	ResultadosService.getPlantillaMargen(nod.valoracion_margenes,scope.centro.idioma_code,function(data){
                     			if(data.plantilla){
                     				nod = angular.merge(nod, data.plantilla);
                     			}
	                     		scope.loadingFields = false;
                     			//console.log(data);
				               //scope.subanaliticas = data.subanaliticas;
				            });
	                     }
	                   

	                     scope.comprobarDiag = function(nod){
	                     	//console.log(nod);
	                     	if(nod.diagnostico){
	                     		//COMPROBAMOS SI TENEMOS QUE RELLENAR
	                     		ResultadosService.getDiagnosticoBiopPlantilla(nod.diagnostico,scope.centro.idioma_code,function(data){
	                     			if(data.plantilla){
	                     				nod = angular.merge(nod, data.plantilla);
	                     				/*scope.loadingFields = true;
	                     				$timeout(function(){

	                     					scope.loadingFields = false;
	                     				})*/
	                     			}
	                     			//console.log(data);
					               //scope.subanaliticas = data.subanaliticas;
					            });

	                     	}
	                     }

	                     scope.optionsSelect2 = { 
		            		ajax: {
		                        url: "/backend/altcrm/content/select2",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            //nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

		            	scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}
			        });
					
		        }
          }
      }
})();